import { render, staticRenderFns } from "./ViewPaymentMethodComponent.vue?vue&type=template&id=4615b2fc"
import script from "./ViewPaymentMethodComponent.vue?vue&type=script&lang=js"
export * from "./ViewPaymentMethodComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports